import Content from '@components/content';
import { useCoreConfig } from 'context/core-config';
import { useTranslation } from 'react-i18next';
import { setComma, setCurrency } from 'utils/common';

export default function DiscountConstantDisplay() {
  const { discountConstant } = useCoreConfig();
  const { t } = useTranslation();

  return (
    <>
      {discountConstant && discountConstant > 0 ? (
        <div className="text-primary-600 px-[12px] py-[6px] z-[100] text-sm">
          <Content>
            <div className="flex items-center gap-[6px] font-bold w-full justify-center blink">
              <object
                data="/static/icons/fire-svgrepo-com.svg"
                className="h-[18px] w-[18px]"
              />
              <span>
                {t('panther:order_discount_notice', {
                  amount: setCurrency('kr', setComma(discountConstant)),
                })}
              </span>
            </div>
          </Content>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
